export function resolveSearchCountry(abbreviation, countryId) {
  const value = String(abbreviation || '').trim().toLowerCase();
  const aliases = { bel: 'be', belgium: 'be', nld: 'nl', netherlands: 'nl', '1': 'nl', '4': 'be' };
  if (aliases[value]) return aliases[value];
  if (/^[a-z]{2}$/.test(value)) return value;
  return aliases[String(countryId || '')] || null;
}

export async function runSuggestionProviders(providers, { signal, onResults, timeoutMs = 12000 } = {}) {
  const results = new Map();
  const sortedResults = () => [...results.values()].flat().sort((a, b) =>
    a.display_name.localeCompare(b.display_name, undefined, { sensitivity: 'base', numeric: true }));
  const outcomes = await Promise.allSettled(providers.map(async (provider, index) => {
    const controller = new AbortController();
    let timer;
    let onAbort;
    try {
      const deadline = new Promise((_, reject) => {
        onAbort = () => {
          controller.abort();
          reject(new Error('Search cancelled'));
        };
        if (signal?.aborted) { onAbort(); return; }
        signal?.addEventListener('abort', onAbort, { once: true });
        timer = setTimeout(() => {
          controller.abort();
          reject(new Error('Search provider timed out'));
        }, timeoutMs);
      });
      const rows = await Promise.race([Promise.resolve().then(() => provider(controller.signal)), deadline]);
      results.set(index, rows);
      const combined = sortedResults();
      if (!signal?.aborted && combined.length) onResults?.(combined);
      return rows;
    } finally {
      clearTimeout(timer);
      signal?.removeEventListener('abort', onAbort);
    }
  }));
  const combined = sortedResults();
  if (!combined.length) {
    const failure = outcomes.find(outcome => outcome.status === 'rejected');
    if (failure) throw failure.reason;
  }
  return combined;
}
